import { render, staticRenderFns } from "./SearchFilters.vue?vue&type=template&id=52dfad22&"
import script from "./SearchFilters.vue?vue&type=script&lang=js&"
export * from "./SearchFilters.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilters.vue?vue&type=style&index=0&id=52dfad22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports